export const IS_DEV = import.meta.env.MODE === 'development';
export const DOMAIN = import.meta.env.VITE_DOMAIN || 'http://localhost:1105';
export const SEGMENT_ANALYTICS_KEY = import.meta.env.VITE_SEGMENT_API_KEY || '';
export const SEGMENT_ENV = import.meta.env.VITE_SEGMENT_ENV || '';
export const SEGMENT_COOKIE_DOMAIN = import.meta.env.VITE_SEGMENT_COOKIE_DOMAIN || '';
export const DISABLE_DATA_PERSISTANCE = import.meta.env.VITE_DISABLE_DATA_PERSISTANCE;
export const DATE_FORMAT = 'DD-MM-YYYY';

export const MSW_LOGGING = import.meta.env.VITE_MSW_LOGGING
  ? import.meta.env.VITE_MSW_LOGGING === 'false'
  : true;
export const MSW_UNHANDLED_REQUESTS = import.meta.env.VITE_MSW_UNHANDLED_REQUESTS || 'bypass';
export const VITE_MOCK_ONLY = import.meta.env.VITE_MOCK_ONLY === 'true';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const DISABLE_IFRAME_BG_LOADING = import.meta.env.VITE_DISABLE_IFRAME_BG_LOADING;
export const MOCK_TIMING = import.meta.env.VITE_MOCK_TIMING;
